import { Component, EventEmitter, Input, Output } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'
import { Dialog } from 'primeng/dialog'

import { Tsp } from '@ti/contracts'

import { TspForm } from '../../contracts'
import { AccountFormComponent } from '../form/account-form.component'

@Component({
  selector: 'app-ti-edit-account-dialog',
  templateUrl: 'edit-account-dialog.component.html',
  styleUrl: 'edit-account-dialog.component.scss',
  imports: [Dialog, TranslatePipe, AccountFormComponent],
})
export class EditAccountDialogComponent {
  @Output() cancelled = new EventEmitter<void>()
  @Output() updated = new EventEmitter<TspForm>()

  @Input() processing = false
  @Input() opened = false
  @Input() account: Partial<Tsp> | null | undefined = {}
  @Input() errorMessage = ''
}
